export function shortAddr(addr, lead = 6, tail = 4) {
  if (!addr) return "—";
  if (addr.length <= lead + tail + 2) return addr;
  return `${addr.slice(0, lead)}…${addr.slice(-tail)}`;
}

export function formatUSD(raw, decimals = 6) {
  if (raw === undefined || raw === null) return "—";
  const s = raw.toString();
  const intPart = s.length > decimals ? s.slice(0, s.length - decimals) : "0";
  let frac = s.length > decimals ? s.slice(-decimals) : s.padStart(decimals, "0");
  // trim trailing zeros but keep 2 decimal min
  frac = frac.replace(/0+$/, "").padEnd(2, "0");
  const grouped = Number(intPart).toLocaleString("en-US");
  return `${grouped}.${frac}`;
}

export function timeAgo(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = Math.max(0, (Date.now() - d.getTime()) / 1000);
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleString();
}

export function copyToClipboard(text) {
  if (navigator?.clipboard?.writeText) return navigator.clipboard.writeText(text);
  const ta = document.createElement("textarea");
  ta.value = text;
  document.body.appendChild(ta);
  ta.select();
  document.execCommand("copy");
  document.body.removeChild(ta);
  return Promise.resolve();
}
